import type { Fleet } from "../api/types";

// UI tabs. "core" and "integration" are flat cluster tables; "argots" is the
// promotion tree; "timeline" is the forward-looking promotion schedule; "branches"
// shows core-aws-k8s-clusters per-cluster branch drift vs develop. Integration
// clusters are the argots server fleet (im-*/int_*), so "integration", "argots" and
// "timeline" all read the same overview — see tabFleet().
// "assistant" is independent of the fleet overview: the effective GenFX Assistant
// config per cluster/namespace from the 3-layer Helm merge.
export type Tab = "core" | "integration" | "argots" | "timeline" | "branches" | "assistant";

const TABS: { tab: Tab; label: string }[] = [
    { tab: "core", label: "Core" },
    { tab: "integration", label: "Integration" },
    { tab: "argots", label: "ArgoTS" },
    { tab: "timeline", label: "Timeline" },
    { tab: "branches", label: "AWS K8s Branches" },
    { tab: "assistant", label: "Assistant Config" },
];

export function tabFleet(tab: Tab): Fleet {
    return tab === "core" ? "core" : "argots";
}

export default function FleetToggle({ tab, onChange }: { tab: Tab; onChange: (tab: Tab) => void }) {
    return (
        <div className="fleet-switch">
            {TABS.map(({ tab: t, label }) => (
                <button key={t} className={`btn ${tab === t ? "active" : ""}`} onClick={() => onChange(t)}>
                    {label}
                </button>
            ))}
        </div>
    );
}
